/*
  assets/hrc-diagnostic-print.js
  P0-C (2a ronda de correcciones): informe PDF profesional independiente.

  Sustituye por completo la implementacion anterior (window.print() de la
  pagina viva, que producia una captura larga con menu, barra promocional y
  fondo oscuro). Este modulo construye un DOCUMENTO HTML NUEVO Y AISLADO --
  sin relacion de DOM con la app -- a partir unicamente del objeto de
  resultado ya calculado (result, recommendations, state, extras). Ese
  documento se abre en una pestana/ventana nueva (via Blob + URL.createObjectURL,
  no document.write) y se imprime SOLO ese documento: la pagina del
  diagnostico nunca se navega ni se pierde su estado.

  No incluye: menu de Shopify, barra promocional, botones, campos de
  formulario ni fondo oscuro. Diseno A4, fondo blanco, texto oscuro, verde
  corporativo #00864B, 4 paginas logicas con salto de pagina controlado y
  `break-inside: avoid` en las tarjetas.
*/
(function () {
  'use strict';

  var LOGO_URL = 'https://hugoromerocoach.com/cdn/shop/files/PEAK_SOCCER_5.png?v=1754386865&width=120';
  var LEVEL_LABELS = { starting_point: 'Punto de partida', developing: 'En desarrollo', functional: 'Nivel funcional', advanced: 'Nivel avanzado', consolidated: 'Nivel consolidado' };
  var LAYER_LABELS = { knowledge: 'Conocimiento', application: 'Aplicación', consistency: 'Consistencia', demand: 'Bajo exigencia', review: 'Revisión' };

  function esc(str) {
    return (str === null || str === undefined ? '' : String(str))
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function contextSummary(state, extras) {
    var audience = state.audience;
    var context = state.context || {};
    var options = extras.contextOptions || {};
    var fieldOrder = audience === 'coach' ? ['role', 'context', 'moment'] : ['position', 'levelContext', 'moment'];
    var parts = [];
    fieldOrder.forEach(function (key) {
      var value = context[key];
      var list = options[key];
      if (!value || !list) return;
      var match = list.filter(function (o) { return o.value === value; })[0];
      if (match) parts.push(match.label);
    });
    var line1 = parts.join(' · ');
    var goalList = options.goal;
    var goalMatch = goalList && context.goal ? goalList.filter(function (o) { return o.value === context.goal; })[0] : null;
    var line2 = goalMatch ? ('Objetivo: ' + goalMatch.label) : '';
    return { line1: line1, line2: line2 };
  }

  function roleLabel(state, extras) {
    if (state.audience !== 'coach') return 'Jugador';
    var options = (extras.contextOptions && extras.contextOptions.role) || [];
    var match = options.filter(function (o) { return o.value === state.context.role; })[0];
    return 'Entrenador / staff' + (match ? ' — ' + esc(match.label) : '');
  }

  function barRow(label, score, score100) {
    var pct = Math.max(0, Math.min(100, typeof score100 === 'number' && !isNaN(score100) ? score100 : Math.round(((score - 1) / 4) * 100)));
    return '' +
      '<div class="p-bar-row">' +
        '<span class="p-bar-label">' + esc(label) + '</span>' +
        '<span class="p-bar-track"><span class="p-bar-fill" style="width:' + pct + '%"></span></span>' +
        '<span class="p-bar-value">' + score.toFixed(1) + '/5</span>' +
      '</div>';
  }

  function recommendationRow(rec) {
    if (!rec) return '';
    var slotLabel = { free: 'Recurso gratuito', main: 'Recomendación principal', complement: 'Complemento', upcoming: 'Próximamente' }[rec.slot] || '';
    return '' +
      '<div class="p-rec-row">' +
        '<span class="p-rec-slot">' + esc(slotLabel) + '</span>' +
        '<strong>' + esc(rec.title) + '</strong>' +
        '<p>' + esc(rec.reason) + '</p>' +
      '</div>';
  }

  function buildPrintableReport(payload) {
    var result = payload.result;
    var recommendations = payload.recommendations || {};
    var state = payload.state;
    var extras = payload.extras || {};
    var audience = state.audience;
    var today = new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' });
    var summary = contextSummary(state, extras);
    var bottleneckText = extras.bottleneckExplanation || (result.bottleneck.type === 'clear'
      ? 'Tu patrón muestra un punto de apoyo claro para seguir progresando.'
      : 'Tu patrón es combinado, sin un único punto de apoyo claro.');
    var bottleneckTag = 'Patrón HRC detectado: ' + (LAYER_LABELS[result.bottleneck.layer] || result.bottleneck.layer).toLowerCase() + '.';
    var strengthLabel = (result.strongestAreas || []).map(function (a) { return a.label; }).join(' y ');
    var versionLine = 'Versión del cuestionario: ' + (audience === 'coach' ? 'COACH_CONTENT_V1.1' : 'PLAYER_CONTENT_V1.1') +
      ' · Versión de puntuación: ' + result.version;

    var barsHtml = result.areaScores.map(function (a) { return barRow(a.label, a.score, a.score100); }).join('');

    var adviceHtml = (result.advice || []).map(function (a) {
      return '<div class="p-card p-advice"><h4>' + esc(a.areaLabel) + '</h4><p>' + esc(a.advice) + '</p></div>';
    }).join('');

    var actionsHtml = (result.actions || []).map(function (a, i) {
      return '<div class="p-card p-action"><span class="p-action-num">' + (i + 1) + '</span><div><span class="p-action-area">' + esc(a.areaLabel) + '</span><p>' + esc(a.action) + '</p></div></div>';
    }).join('');

    var recsHtml = ['free', 'main', 'complement', 'upcoming'].map(function (slot) { return recommendationRow(recommendations[slot]); }).join('');
    if (!recommendations.hasMatch) {
      recsHtml = '<p class="p-muted">Todavía no tenemos un recurso que encaje con suficiente precisión en tu situación actual. Aplica las acciones prácticas de este informe: son el paso más eficaz ahora mismo.</p>';
    }

    var priority2Html = '';
    if (result.priority2) {
      priority2Html = '<p><strong>Prioridad secundaria' + (result.connectedPriorities ? ' (conectada)' : '') + ':</strong> ' + esc(result.priority2.label) + '</p>';
      if (result.connectedPriorities) {
        priority2Html += '<p class="p-muted">"' + esc(result.priority1.label) + '" y "' + esc(result.priority2.label) + '" están conectadas: mejorar una suele facilitar la otra.</p>';
      }
    }

    var alertHtml = '';
    if (result.alert && result.alert.active) {
      alertHtml = '<div class="p-card p-alert"><h4>Un aviso importante</h4><p>Tus respuestas indican una posible molestia, fatiga o limitación física que conviene priorizar. Este diagnóstico es orientativo: no sustituye la valoración de tu entrenador, fisioterapeuta o médico. Por eso este informe no recomienda ningún plan de preparación física intensa como opción principal.</p></div>';
    }

    var doc = '' +
'<!doctype html><html lang="es"><head><meta charset="utf-8">' +
'<title>Informe Diagnóstico HRC — ' + esc(state.lead && state.lead.name) + '</title>' +
'<style>' +
'  @page { size: A4; margin: 16mm 14mm; }' +
'  * { box-sizing: border-box; }' +
'  body { font-family: -apple-system, "Inter", Arial, sans-serif; color: #16211a; background: #fff; margin: 0; font-size: 11.5px; line-height: 1.5; }' +
'  .p-page { page-break-after: always; padding-bottom: 10mm; min-height: 250mm; position: relative; }' +
'  .p-page:last-child { page-break-after: auto; }' +
'  .p-header { display: flex; align-items: center; justify-content: space-between; border-bottom: 2px solid #00864B; padding-bottom: 8px; margin-bottom: 18px; }' +
'  .p-header img { height: 28px; display: block; }' +
'  .p-header .p-brand { font-weight: 700; font-size: 11px; color: #55605a; letter-spacing: .3px; }' +
'  .p-footer { position: absolute; bottom: 0; left: 0; right: 0; display: flex; justify-content: space-between; font-size: 9px; color: #9aa39a; border-top: 1px solid #e2e6e0; padding-top: 6px; }' +
'  h1 { font-size: 22px; margin: 4px 0 4px; color: #0c0f0c; }' +
'  h2 { font-size: 16px; margin: 0 0 14px; color: #0c0f0c; border-left: 4px solid #00864B; padding-left: 10px; }' +
'  h3 { font-size: 13px; margin: 0 0 6px; }' +
'  h4 { font-size: 11.5px; margin: 0 0 4px; text-transform: uppercase; letter-spacing: .2px; color: #00864B; }' +
'  p { margin: 0 0 8px; }' +
'  .p-eyebrow { display: inline-block; background: #eaf5ee; color: #00864B; font-size: 10px; font-weight: 700; text-transform: uppercase; padding: 3px 10px; border-radius: 100px; margin-bottom: 10px; }' +
'  .p-meta-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4px 24px; margin: 14px 0; font-size: 11.5px; }' +
'  .p-meta-grid strong { color: #55605a; font-weight: 600; display: inline-block; min-width: 70px; }' +
'  .p-score-box { background: #f4f9f5; border: 1px solid #cfe6d7; border-radius: 10px; padding: 16px 20px; margin: 18px 0; text-align: center; }' +
'  .p-score-box .p-score-value { font-size: 30px; font-weight: 700; color: #00864B; }' +
'  .p-score-box .p-score-level { font-size: 12px; color: #55605a; margin-top: 4px; }' +
'  .p-disclaimer { font-size: 9.5px; color: #7a847a; margin-top: 16px; }' +
'  .p-card { border: 1px solid #e2e6e0; border-radius: 8px; padding: 10px 14px; margin-bottom: 8px; break-inside: avoid; }' +
'  .p-bar-row { display: grid; grid-template-columns: 150px 1fr 46px; align-items: center; gap: 8px; margin-bottom: 8px; break-inside: avoid; }' +
'  .p-bar-label { font-size: 11px; color: #4b554c; }' +
'  .p-bar-track { height: 8px; background: #eef1ed; border-radius: 100px; overflow: hidden; }' +
'  .p-bar-fill { display: block; height: 100%; background: #00864B; }' +
'  .p-bar-value { font-size: 11px; text-align: right; color: #16211a; font-weight: 600; }' +
'  .p-tag-line { display: inline-block; font-size: 9.5px; color: #9aa39a; text-transform: uppercase; letter-spacing: .2px; margin-top: 2px; }' +
'  .p-muted { color: #6f7a6d; font-size: 10.5px; }' +
'  .p-action { display: flex; gap: 10px; align-items: flex-start; }' +
'  .p-action-num { flex-shrink: 0; width: 20px; height: 20px; border-radius: 50%; background: #00864B; color: #fff; font-weight: 700; font-size: 11px; display: flex; align-items: center; justify-content: center; }' +
'  .p-action-area { display: block; font-size: 9.5px; text-transform: uppercase; color: #9aa39a; margin-bottom: 2px; }' +
'  .p-alert { background: #fdf6e8; border-color: #f2c14e; }' +
'  .p-alert h4 { color: #a3781c; }' +
'  .p-rec-row { border-bottom: 1px solid #eee; padding: 8px 0; break-inside: avoid; }' +
'  .p-rec-slot { display: block; font-size: 9.5px; font-weight: 700; color: #00864B; text-transform: uppercase; margin-bottom: 2px; }' +
'  .p-repeat-link { color: #00864B; font-weight: 600; }' +
'  .p-legal { font-size: 9.5px; color: #7a847a; border-top: 1px solid #e2e6e0; padding-top: 10px; margin-top: 16px; }' +
'  @media print { .p-page { min-height: 0; } }' +
'</style></head><body>' +

'<section class="p-page">' +
  '<div class="p-header"><img src="' + LOGO_URL + '" alt="Hugo Romero Coach"><span class="p-brand">DIAGNÓSTICO HRC</span></div>' +
  '<span class="p-eyebrow">Informe personalizado</span>' +
  '<h1>Diagnóstico HRC — Informe personalizado</h1>' +
  '<div class="p-meta-grid">' +
    '<div><strong>Nombre:</strong> ' + esc(state.lead && state.lead.name) + '</div>' +
    '<div><strong>Fecha:</strong> ' + esc(today) + '</div>' +
    '<div><strong>Perfil:</strong> ' + roleLabel(state, extras) + '</div>' +
    '<div><strong>Contexto:</strong> ' + esc(summary.line1) + '</div>' +
  '</div>' +
  (summary.line2 ? '<p class="p-muted">' + esc(summary.line2) + '</p>' : '') +
  '<div class="p-score-box">' +
    '<div class="p-score-value">' + result.generalScore.toFixed(1) + ' / 5</div>' +
    '<div class="p-score-level">' + esc(LEVEL_LABELS[result.generalLevel.key] || result.generalLevel.label) + '</div>' +
  '</div>' +
  '<p class="p-disclaimer">Este es un autodiagnóstico orientativo, no una evaluación científica, médica ni psicológica. Se basa en tu propia percepción durante las últimas cuatro semanas.</p>' +
  '<div class="p-footer"><span>Hugo Romero Coach · Diagnóstico HRC</span><span>Página 1 de 4</span></div>' +
'</section>' +

'<section class="p-page">' +
  '<div class="p-header"><img src="' + LOGO_URL + '" alt="Hugo Romero Coach"><span class="p-brand">DIAGNÓSTICO HRC</span></div>' +
  '<h2>Resultados por área</h2>' +
  barsHtml +
  '<h2 style="margin-top:22px;">Tu perfil</h2>' +
  '<div class="p-card"><h3>Fortaleza' + ((result.strongestAreas || []).length > 1 ? 's' : '') + '</h3><p>' + esc(strengthLabel) + '</p></div>' +
  '<div class="p-card"><h3>Prioridad principal</h3><p>' + esc(result.priority1.label) + '</p>' + priority2Html + '</div>' +
  '<div class="p-card"><h3>Tu patrón</h3><p>' + esc(bottleneckText) + '</p><span class="p-tag-line">' + esc(bottleneckTag) + '</span></div>' +
  '<div class="p-footer"><span>Hugo Romero Coach · Diagnóstico HRC</span><span>Página 2 de 4</span></div>' +
'</section>' +

'<section class="p-page">' +
  '<div class="p-header"><img src="' + LOGO_URL + '" alt="Hugo Romero Coach"><span class="p-brand">DIAGNÓSTICO HRC</span></div>' +
  '<h2>Miniconsejos por área</h2>' +
  adviceHtml +
  '<div class="p-footer"><span>Hugo Romero Coach · Diagnóstico HRC</span><span>Página 3 de 4</span></div>' +
'</section>' +

'<section class="p-page">' +
  '<div class="p-header"><img src="' + LOGO_URL + '" alt="Hugo Romero Coach"><span class="p-brand">DIAGNÓSTICO HRC</span></div>' +
  '<h2>Tus 3 acciones para esta semana</h2>' +
  actionsHtml +
  alertHtml +
  '<h2 style="margin-top:18px;">Tu ruta recomendada</h2>' +
  recsHtml +
  '<p style="margin-top:16px;">Repite tu diagnóstico en cualquier momento: <span class="p-repeat-link">hugoromerocoach.com' + esc(payload.pagePath || '') + '</span></p>' +
  '<div class="p-legal">' + esc(versionLine) + '<br>Documento generado automáticamente a partir de tus respuestas del ' + esc(today) + '. Es un contenido orientativo y no sustituye la valoración de un entrenador, preparador físico o profesional cualificado.</div>' +
  '<div class="p-footer"><span>Hugo Romero Coach · Diagnóstico HRC</span><span>Página 4 de 4</span></div>' +
'</section>' +

'</body></html>';

    return doc;
  }

  function openAndPrint(payload) {
    var html = buildPrintableReport(payload);
    var blob = new Blob([html], { type: 'text/html' });
    var url = URL.createObjectURL(blob);
    var win = window.open(url, '_blank');
    if (!win) return { opened: false };
    // Se imprime SOLO esta ventana nueva; la pagina del diagnostico original
    // nunca se navega, por lo que cancelar el dialogo de impresion y volver
    // no borra ni afecta el progreso guardado.
    win.addEventListener('load', function () {
      win.focus();
      win.print();
      setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
    });
    return { opened: true };
  }

  window.HRC_DIAGNOSTIC_PRINT = { buildPrintableReport: buildPrintableReport, openAndPrint: openAndPrint };
})();
